import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserService {
  private _role = '';

  constructor() {}

  get role(): string {
    let val = this._role;
    if (!val) {
      const path = window.location.pathname;
      const segments = path.split('/').filter(Boolean);
      val = segments[0];
      if (val === 'insured' || val === 'broker') {
        this._role = val;
        return val;
      }
      if (!val) {
        const params = new URLSearchParams(window.location.search);
        const requestKey = params.get('key');
        if (requestKey.charAt(0).toLowerCase() == 'i') {
          this._role = 'insured';
          return 'insured';
        }
        if (requestKey.charAt(0).toLowerCase() == 'b') {
          this._role = 'broker';
          return 'broker';
        }
      }
    }
    return this._role;
  }
  set role(value: string) {
    this._role = value;
  }
}
